// adds a space after thousands e.g: 1 000 SEK, 12 300 SEK etc.
export function formatCurrency(value) {
  return `${String(value).replace(/(\d)(?=(?:[0-9]{3})+\b)/g, '$1 ')} SEK`;
}
